'use es6';

import hubapiStack from 'hub-http/stacks/hubapi';
import rxjsClient from '../adapters/rxjsClient';
export default rxjsClient(hubapiStack);